import { Modal } from "flowbite-react";
import FormExternalServices from "../forms/FormRegisterExternalServices";

type Props = {
    onClose: () => void
    onSave?: () => void 
}

export default function ModalRegisterExternalServices({ onClose, onSave }: Props) {
    const handleCloseModal = () => {
        onSave?.()      
        onClose()     
    }

    return (
        <Modal className='relative text-black' size="5xl" show={true} onClose={onClose}>
            <Modal.Header className='text-black dark:text-black'>
                <h2 className="text-black">Novo Serviço Externo</h2>
            </Modal.Header>
            <Modal.Body className='text-black dark:text-black'>
                <FormExternalServices onSubmit={handleCloseModal} />
            </Modal.Body>
        </Modal>
    )
}
